import { TradingDocument } from "api/trading-documents/models";
import { FinanceAmountFormat } from "components/common/financeAmountFormat";
import { RightPanelSection, RightPanelTableRow } from "components/utils/drawer";
import { currencyConvertSectionListConfig } from "pages/tradingDocuments/shared/utils/panelTablesConfig";
import { CurrencyConvert } from "./components/CurrencyConvert";

interface Props {
  salesInvoice: TradingDocument;
}

export const CurrencyConvertSection = ({ salesInvoice }: Props) => {
  return (
    <RightPanelSection>
      <div className="pt-4">
        <RightPanelTableRow grid={currencyConvertSectionListConfig.grid} hover={false}>
          <div>kurs</div>
          <div>z dnia</div>
          <div></div>
          <div>VAT</div>
          <div className="d-flex align-items-center justify-content-end">wartość netto</div>
          <div className="d-flex align-items-center justify-content-end">kwota VAT</div>
          <div className="d-flex align-items-center justify-content-end">wartość brutto</div>
        </RightPanelTableRow>
        {salesInvoice.amountSummaryPerVatRateCurrencyConvert.map((currencyConvert, index) => (
          <CurrencyConvert currencyConvert={currencyConvert} key={index} />
        ))}
        <RightPanelTableRow grid={currencyConvertSectionListConfig.grid}>
          <div />
          <div />
          <div className="d-flex align-items-center justify-content-end text-grey-35">suma:</div>
          <div />
          <div className="d-flex align-items-center justify-content-end gap-1">
            {salesInvoice.amountSummaryCurrencyConvert.totalWithoutTax ? (
              <>
                <strong className="body-14 fw-800">
                  <FinanceAmountFormat
                    value={salesInvoice.amountSummaryCurrencyConvert.totalWithoutTax}
                  />
                </strong>
                <div className="fw-700">PLN</div>
              </>
            ) : (
              "--"
            )}
          </div>
          <div className="d-flex align-items-center justify-content-end gap-1">
            {salesInvoice.amountSummaryCurrencyConvert.totalTax ? (
              <>
                <strong className="body-14 fw-800">
                  <FinanceAmountFormat value={salesInvoice.amountSummaryCurrencyConvert.totalTax} />
                </strong>
                <div className="fw-700">PLN</div>
              </>
            ) : (
              "--"
            )}
          </div>
          <div className="d-flex align-items-center justify-content-end gap-1">
            {salesInvoice.amountSummaryCurrencyConvert.totalWithTax ? (
              <>
                <strong className="body-14 fw-800">
                  <FinanceAmountFormat
                    value={salesInvoice.amountSummaryCurrencyConvert.totalWithTax}
                  />
                </strong>
                <div className="fw-700">PLN</div>
              </>
            ) : (
              "--"
            )}
          </div>
        </RightPanelTableRow>
      </div>
      <div>
        <div className="d-flex align-items-center justify-content-end gap-3">
          <div className="d-flex align-items-center justify-content-end body-14-600">
            razem do zapłaty:
          </div>
          <div className="d-flex align-items-center justify-content-end">
            {salesInvoice.amountSummaryCurrencyConvert.totalWithTax ? (
              <strong className="body-18-800">
                <div className="d-flex">
                  <FinanceAmountFormat
                    value={salesInvoice.amountSummaryCurrencyConvert.totalWithTax}
                  />
                  &nbsp;PLN
                </div>
              </strong>
            ) : (
              <strong className="body-18-800">--</strong>
            )}
          </div>
        </div>
      </div>
    </RightPanelSection>
  );
};
